export const embedCodeFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    Livestream player embed code (web only).
  </small>
)

export const pbsStationManagerLivestreamFeedCidFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    {
      "The ID associated with this channel's livestream data in PBS Station Manager."
    }
  </small>
)

export const sourceTabs = [
  {
    id: 0,
    label: 'Embed code',
    name: 'embedCode',
  },
  {
    id: 1,
    label: 'Stream URL',
    name: 'sourceUrl',
  },
  {
    id: 2,
    label: 'PBS Station Manager',
    name: 'pbsStationManager',
  },
  {
    id: 3,
    label: 'Vimeo',
    name: 'vimeoLiveEventId',
  },
]

export const sourceUrlFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    Livestream source URL. Only unencrypted HLS (<code>m3u8</code>) and DASH (
    <code>mpd</code>) formats are supported.
  </small>
)

export const vimeoLiveEventIdFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    Navigate to <a href="https://vimeo.com/library/events">Vimeo Live Events</a>
    , select the live event and copy the ID from the page URL.
  </small>
)

export const xmlTvChannelIdFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    Channel ID of the livestream schedule in the provided XMLTV file.
  </small>
)

export const xmlTvUrlFieldDescription = (
  <small className="block self-center pb-4 text-gray-500">
    URL of a publicly accessible XMLTV compliant schedule data file.
  </small>
)
